import { JWT_KEY } from '@/constants/app';
import Cookies from 'js-cookie';

export const clientCookies = {
  get: Cookies.get,
  set: Cookies.set,
  destroy: Cookies.remove,
};

export const clientJWT = () => {
  return clientCookies.get(JWT_KEY);
};
